import { InjectionToken } from '@angular/core';

export type VhLocale = 'en' | 'hi' | 'gu';

export interface VendorHubEnvironment {
  /** True when built for production (CI/CD). */
  production: boolean;

  /** Base URL of the VendorHub .NET API (no trailing slash). */
  apiBaseUrl: string;

  /** Public origin the app is served from. */
  appBaseUrl: string;

  /** Default locale applied on first load. */
  defaultLocale: VhLocale;

  /** Locales the app ships with. */
  supportedLocales: ReadonlyArray<VhLocale>;

  /** Sentry DSN — null disables error reporting. */
  sentryDsn: string | null;

  /** Runtime feature flags. */
  featureFlags: {
    incrementalHydration: boolean;
    [key: string]: boolean;
  };
}

/**
 * DI token for the current environment. Each app provides its own
 * implementation (`environment.ts` / `environment.prod.ts`).
 */
export const ENVIRONMENT = new InjectionToken<VendorHubEnvironment>('VH_ENVIRONMENT');
